import styled from 'styled-components';

import { Form } from '@components/elements/Form';

export const Card = styled.div`
  width: 100%;

  border: none;
  border-radius: 10px;

  box-shadow: 0 0 30px 0 rgb(82 63 105 / 5%);

  background-color: white;
`;

export const CardHeader = styled.div`
  height: 70px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 30px;

  border-bottom: 1px solid #ebedf3;

  > h1 {
    color: #181c32;
    font-size: 25px;
  }

  > a {
    text-decoration: none;
    border-radius: 10px;

    font-weight: 700;
  }
`;

export const CardContent = styled.div`
  padding: 30px;
`;

export const CreditsForm = styled(Form)`
  transition: opacity 0.4s, visibility 0.4s;
`;

export const VehiclesForm = styled(Form)`
  opacity: 0;
  visibility: hidden;

  display: none;

  transition: opacity 0.4s, visibility 0.4s;
`;

export const PropertiesForm = styled(Form)`
  opacity: 0;
  visibility: hidden;

  display: none;

  transition: opacity 0.4s, visibility 0.4s;
`;
